import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';

import { SharedService } from '../../../../../shared/shared.service';
import { UsersService } from '../../users.service';
import { UserArry } from './user-array';
import { Location } from '@angular/common';
import notify from 'devextreme/ui/notify';
import { UsefulToolsService } from '../../../../../shared/other/usefultools.service';


@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.css']
})
export class UserEditComponent implements OnInit {

  popupVisible = false;
  dataSource: any;
  sessionId = sessionStorage.getItem('com-session-id');
  userId;
  access_level = [{name: 'System Admin', level: 0}, {name: 'Manager', level: 1}]

  constructor(
    public sharedService: SharedService,
    private httpClient: HttpClient,
    public users: UsersService,
    private location: Location,
    private usefultoolsservice: UsefulToolsService
  ) {}

  formatDateStringNoTime = this.sharedService.dateFormatStringNoTime;

  ngOnInit() {
    // this.sharedService.loadingActive = true;
    if (this.users.user === null || this.users.user === undefined) {
      this.location.back();
    } else {
      if (this.users.user === 1) {
        this.dataSource = {ID: sessionStorage.getItem('user-length'), NAME: '', SURNAME: '', TELEPHONE: '', EMAIL: '', PASSWORD: ''};
        this.sharedService.loadingActive = false;
      } else if (this.users.user === 0) {
        this.userId = sessionStorage.getItem('user-id');
        const postSession = {
          SessionID: this.sessionId,
          ID: this.userId
        };
        this.httpClient.post<any>(`${this.sharedService.URLnode}/utUserID`, postSession).subscribe(Response => {
          console.log(Response);
          this.dataSource = Response.recordset == null ? [] : Response.recordset[0];
          console.log(this.dataSource);
          this.sharedService.loadingActive = false;
        });
      } else {
        this.sharedService.loadingActive = false;
        this.location.back();
      }
    }
  }

  onFormSubmit() {

    // validation
    if (this.dataSource.Name === '' || this.dataSource.Name === null) {
      this.usefultoolsservice.notify('error', `Required Name`);
      return;
    }
    if (this.dataSource.TelNo === '' || this.dataSource.TelNo === null) {
      this.usefultoolsservice.notify('error', `Required TelNo`);
      return;
    }
    if (isNaN(this.dataSource.TelNo) === true) {
      this.usefultoolsservice.notify('error', `Cellphone can contain only numerical numbers`);
      return;
    }

    if (this.users.user === 1) {
      const postSession = {
        SessionID: this.sessionId,
        Name: this.dataSource.Name,
        EMail: this.dataSource.EMail,
        Password: this.dataSource.Password,
        TelNo: this.dataSource.TelNo,
        UserID: this.dataSource.UserID,
        ID: sessionStorage.getItem('user-length')
      };
      this.httpClient.post<any>(`${this.sharedService.URLnode}/utInsertUser`, postSession).subscribe(Response => {
        console.log(Response);
        this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successInsert);
        this.location.back();
      });
    } else if (this.users.user === 0) {
      const postSession = {
        SessionID: this.sessionId,
        Name: this.dataSource.Name,
        EMail: this.dataSource.EMail,
        Password: this.dataSource.Password,
        TelNo: this.dataSource.TelNo,
        UserID: this.dataSource.UserID,
        ID: sessionStorage.getItem('user-id'),
        AccessLevel: this.dataSource.AccessLevel
      };
      this.httpClient.post<any>(`${this.sharedService.URLnode}/utUpdateUser`, postSession).subscribe(Response => {
        console.log(Response);
        this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successInsert);
        this.location.back();
      });
    }
  }

  delete() {
    // tslint:disable-next-line:max-line-length
    // this.httpClient.delete<any>(`${this.sharedService.URL}/dbDriver?SessionID=${this.sessionId}&ID=${this.driverId}`).subscribe(Response => {
    //   if (Response.dbDriver_response.ServiceResults[0].hasOwnProperty('ERRORDESCRIPTION')) {
    //     if (Response.dbDriver_response.ServiceResults[0].ERRORDESCRIPTION === 'Error occured Deleting the record 30] Entry Not Found [0]') {
    //       notify('Cannot delete this record. It is linked to other records in the database.', 'error', 5000);
    //     } else {
    //       this.usefultoolsservice.notify('error', `Error: ${Response.dbDriver_response.ServiceResults[0].ERRORDESCRIPTION}`);
    //     }
    //     this.popupVisible = false;
    //   } else {
    //     this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successDelete);
    //     this.location.back();
    //   }
    // });
  }

  toggle(data) {
    if (data === true) {
      this.popupVisible = true;
    } else {
      this.popupVisible = false;
    }
  }
}
